import {InvoiveCountTableHeadersType, TableHeadersType} from "./tableHeadersType";

export const INVOICE_COUNT_HEADERS: InvoiveCountTableHeadersType[] = [
  {
    "label": "Client Code",
    "value": "client_code",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Client Name",
    "value": "client_name",
    "defaultChecked": true,
    "checked": true
    },
   
  {
    "label": "Total Expenses",
    "value": "total_expenses_count",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Total Sales",
    "value": "total_revenues_count",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Total Others",
    "value": "total_others_count",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Total Manufacturing",
    "value": "total_bom_count",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Total",
    "value": "total_count",
    "defaultChecked": true,
    "checked": true
  },
];

export const USER_WISE_INVOICE_COUNT_REPORT_HEADERS: TableHeadersType[] = [
  {
    label: "Date",
    value: "date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Total Expenses Count",
    value: "total_expenses_count",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "Total Revenues Count",
    value: "total_revenues_count",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "Total Others Count",
    value: "total_others_count",
    defaultChecked: true,
    checked: true,
  },
];